import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "LiquidityPlanGlobal" })((theme) => ({
  page: {
    margin: "20px",
  },
}));
